import React from 'react';
import './App.css';
import Header from './components/Header.jsx';
import BookingForm from './components/BookingForm.jsx';

function App() {
  return (
    <div className="App">
      <Header />
      <BookingForm />
    </div>
  );
}

export default App;
